/*
 * mei-shape-swap.js — Meiara in-page shape swap (Route A)
 * --------------------------------------------------------
 * Shapes in a family are separate products linked via the
 * custom.related_shape_products metafield and rendered by
 * snippets/shape-variant.liquid as <a class="shape-link"> links.
 *
 * This enhances those links so clicking a shape SOFT-LOADS that shape's
 * product into the current PDP — gallery, price, carat options and
 * Add-to-Cart all update with NO full page reload (URL is updated via
 * history.pushState so links/SEO/back-button stay correct).
 *
 * SAFETY: the links remain real <a href> targets. This script only
 * *enhances* a plain left-click, and ANY failure (fetch error, parse
 * error, missing module) falls back to normal navigation. So it can
 * never leave the shopper on a broken page — worst case it behaves
 * exactly like today (a normal navigation to the shape's product).
 */
(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-section-type="product"]';
  var LINK_SELECTOR = '.related-shapes a.shape-link';
  var didSwap = false;

  // Minimal loading-state style, kept self-contained in this asset.
  try {
    var st = document.createElement('style');
    st.textContent =
      '.mei-swapping .photos__item--main{opacity:.45;transition:opacity .2s ease;pointer-events:none}' +
      '.related-shapes .shape-link{cursor:pointer}';
    document.head.appendChild(st);
  } catch (e) {}

  function currentSection() {
    return document.querySelector(SECTION_SELECTOR);
  }

  // Rebuild the theme's product module (Slick gallery + variant selectors +
  // price + Add-to-Cart) against the freshly injected DOM.
  function reinitProduct(sectionEl) {
    if (window.theme && typeof theme.Product === 'function') {
      new theme.Product(sectionEl); // constructor reads #ProductJson-{id} inside
    }
  }

  // Make swapped-in media visible. Two theme effects hide fresh nodes:
  //  1. AOS (data-aos="fade") holds the gallery wrapper at opacity:0 until it
  //     adds .aos-animate on scroll — which never fires for injected nodes.
  //  2. lazysizes holds images at opacity:.3 until .lazyloaded is added.
  // The gallery is already in view, so just drop the AOS hook and unveil images.
  function revealMedia(root) {
    root.querySelectorAll('[data-aos]').forEach(function (el) {
      el.removeAttribute('data-aos');
      el.classList.remove('aos-init', 'aos-animate');
      el.style.opacity = '';
    });
    root.querySelectorAll('img.lazyload').forEach(function (img) {
      try {
        if (window.lazySizes && lazySizes.loader && lazySizes.loader.unveil) {
          lazySizes.loader.unveil(img);
        }
      } catch (e) {}
      img.classList.remove('lazyload');
      img.classList.add('lazyloaded');
    });
  }

  // Best-effort refresh of third-party widgets after a swap.
  function refreshAux() {
    try { if (window.jdgm && jdgm.batchRenderBadges) jdgm.batchRenderBadges(); } catch (e) {}
  }

  function swap(url, sectionEl) {
    var sectionId = sectionEl.getAttribute('data-section-id');

    // Tear down existing slick galleries so their global handlers don't leak.
    try {
      if (window.jQuery) {
        jQuery('.gallery-wrap' + sectionId + ', .product-single__thumbnails-' + sectionId)
          .each(function () { try { jQuery(this).slick('unslick'); } catch (e) {} });
      }
    } catch (e) {}

    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector(SECTION_SELECTOR);
        var live = currentSection();
        if (!fresh || !live) throw new Error('product section not found');

        // Swap the whole product section's contents to the target product.
        live.innerHTML = fresh.innerHTML;
        // Carry over identifying data attributes.
        ['data-handle'].forEach(function (a) {
          if (fresh.hasAttribute(a)) live.setAttribute(a, fresh.getAttribute(a));
        });

        reinitProduct(live);
        revealMedia(live); // after reinit so Slick's cloned slides are covered too
        refreshAux();

        // Update tab title + address bar without reloading.
        var titleEl = doc.querySelector('title');
        if (titleEl) document.title = titleEl.textContent;
        history.pushState({ meiShapeSwap: true }, '', url);
        didSwap = true;

        return true;
      });
  }

  // Delegated on document so it survives section innerHTML replacement.
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest(LINK_SELECTOR) : null;
    if (!link) return;

    // Respect new-tab / modified clicks — let the browser handle them.
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey ||
        e.shiftKey || e.altKey) return;

    var section = currentSection();
    var url = link.getAttribute('href');
    if (!section || !url) return; // no section / no href → normal navigation

    // Clicking the already-selected shape: nothing to load.
    if (link.querySelector('.active_shape')) { e.preventDefault(); return; }

    e.preventDefault();
    section.classList.add('mei-swapping');

    swap(url, section)
      .catch(function (err) {
        // Hard fallback: behave exactly like a normal link click.
        if (window.console) console.warn('[mei-shape-swap] fallback to navigation:', err);
        window.location.href = url;
      })
      .then(function () {
        var s = currentSection(); // ref may be stale after innerHTML swap
        if (s) s.classList.remove('mei-swapping');
      });
  });

  // Back/forward across swapped states: reload to guarantee correct content.
  window.addEventListener('popstate', function () {
    if (didSwap) window.location.reload();
  });
})();
